import React, { useState } from "react";
import { useStyles } from "./DecisionReviewContentStyles.css";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Button } from "@mui/material";
import { Dialog } from "@mui/material";
import { DialogActions } from "@mui/material";
import { DialogContent } from "@mui/material";
import { TextField } from "@mui/material";
import { DialogContentText } from "@mui/material";
import { DialogTitle } from "@mui/material";
import useSubmitChallengeDecision from "./useSubmitChallengeDecision";
import { useIntl, FormattedMessage } from "react-intl";
import LoadingProgressIndication from "components/commons/elements/progress/loading/LoadingProgressIndication";
// Component for rendering the information on the top bar during the review mode
// This means the player's decision, the correct decision, whether the decision was correct,
// information about the technique etc

const DecisionReviewContent = ({
    matchedDecisions,
    activeStep,
    sessionInfo,
    sessionType,
    loading,
}) => {
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false);
    const intl = useIntl();
    const [playerNotes, setPlayerNotes] = useState("");

    const { savePlayerInputs } = useSubmitChallengeDecision();

    const handleOpenDialog = () => {
        setIsOpen(true);
    };

    const handleCloseDialog = () => {
        setIsOpen(false);
    };

    const handleChangeText = (e) => {
        setPlayerNotes(e.target.value);
    };

    const handleClickSubmit = () => {
        savePlayerInputs(
            matchedDecisions.aggregatedDecisions[activeStep].definedDecision.key,
            sessionInfo.scoredSceneId,
            sessionInfo.playlistId,
            sessionInfo.courseId,
            playerNotes
        );

        setIsOpen(false);
        setPlayerNotes("");
    };
    console.log(loading);
    if (loading) {
        return (
            <LoadingProgressIndication
                style={{ color: "white" }}
                text={intl.formatMessage({
                    id: "app.game.loading.scene",
                    defaultMessage: "Loading feedback...",
                })}
            />
        );
    }

    const missedOrMatched = (pair) => {
        if (
            matchedDecisions.aggregatedDecisions[activeStep].playerDecision !==
            undefined
        ) {
            return true;
        } else {
            return false;
        }
    };
    return missedOrMatched(matchedDecisions.aggregatedDecisions[activeStep]) ? (
        <div className={classes.reviewContainer}>
            <div className={classes.contentLeft}>
                <div className={classes.contentLeftDecisionOverview}>
                    <FormattedMessage
                        id={"app.game.review.content.your.score"}
                        defaultMessage={"Your Score: "}
                    />
                    <b
                        style={{
                            color:
                                matchedDecisions.aggregatedDecisions[activeStep].playerDecision
                                    .athlete === "red"
                                    ? "red"
                                    : "blue",
                        }}
                    >
                        {
                            matchedDecisions.aggregatedDecisions[activeStep].playerDecision
                                .score
                        }
                    </b>
                    <br />
                    <FormattedMessage
                        id={"app.game.review.content.correct.score"}
                        defaultMessage={"Correct Score: "}
                    />
                    <b
                        style={{
                            color:
                                matchedDecisions.aggregatedDecisions[activeStep].definedDecision
                                    .athlete === "red"
                                    ? "red"
                                    : "blue",
                        }}
                    >
                        {
                            matchedDecisions.aggregatedDecisions[activeStep].definedDecision
                                .score
                        }
                    </b>
                    <br />
                    <FormattedMessage
                        id={"app.game.review.content.reaction.time"}
                        defaultMessage={"Reaction Time: "}
                    />{" "}
                    {parseFloat(
                        `${matchedDecisions.aggregatedDecisions[activeStep].reactionTime}`
                    ).toFixed(3)}
                </div>
                <div className={classes.contentLeftIcon}>
                    {matchedDecisions.aggregatedDecisions[activeStep].isCorrect ===
                        true ? (
                        <CheckCircleIcon
                            style={{
                                color: "green",
                                fontSize: "60px",
                                marginTop: "1%",
                                marginLeft: "1%",
                            }}
                        />
                    ) : (
                        <CancelIcon
                            style={{
                                color: "red",
                                fontSize: "60px",
                                marginTop: "1%",
                                marginLeft: "1%",
                            }}
                        />
                    )}
                </div>
            </div>

            <div className={classes.contentCenter}>
                <Button
                    className={classes.btnChallengeDecision}
                    onClick={handleOpenDialog}
                >
                    <FormattedMessage
                        id={"app.game.buttons.challenge.decision"}
                        defaultMessage={"Challenge Decision "}
                    />
                </Button>
                <Dialog open={isOpen} onClose={handleCloseDialog}>
                    <DialogTitle>
                        <FormattedMessage
                            id={"app.game.buttons.challenge.decision"}
                            defaultMessage={"Challenge Decision "}
                        />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <FormattedMessage
                                id={"app.game.review.content.challenge.decision.text"}
                                defaultMessage={
                                    "Please enter any additional remarks you may have about this decision. (Max. 200 characters.) "
                                }
                            />
                        </DialogContentText>
                        <TextField
                            autoFocus
                            value={playerNotes}
                            margin="dense"
                            id="name"
                            label="Notes"
                            multiline
                            rows={4}
                            fullWidth
                            inputProps={{ maxLength: 200 }}
                            onChange={handleChangeText}
                            variant="standard"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog}>
                            <FormattedMessage
                                id={"app.game.buttons.challenge.decision.cancel"}
                                defaultMessage={"Cancel"}
                            />
                        </Button>
                        <Button onClick={handleClickSubmit}>
                            <FormattedMessage
                                id={"app.game.buttons.challenge.decision.submit"}
                                defaultMessage={"Submit"}
                            />
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>

            <div className={classes.contentRight}>
                {matchedDecisions.aggregatedDecisions[activeStep].definedDecision.score}{" "}
                {!isNaN(
                    matchedDecisions.aggregatedDecisions[activeStep].definedDecision.score
                )
                    ? "pt"
                    : ""}
                <br />
                <b
                    style={
                        matchedDecisions.aggregatedDecisions[activeStep].definedDecision
                            .athlete === "red"
                            ? { color: "red" }
                            : { color: "blue" }
                    }
                >
                    {intl.formatMessage({
                        id: `app.ids.technique.${matchedDecisions.aggregatedDecisions[activeStep].definedDecision.technique}`,
                        defaultMessage:
                            matchedDecisions.aggregatedDecisions[activeStep].definedDecision
                                .technique,
                    }) +
                        (matchedDecisions.aggregatedDecisions[activeStep].definedDecision
                            .techniqueFreeText
                            ? `: ${matchedDecisions.aggregatedDecisions[activeStep].definedDecision.techniqueFreeText}`
                            : "")}
                </b>
            </div>
        </div>
    ) : (
        <div className={classes.reviewContainer}>
            <div className={classes.contentLeft}>
                <div>
                    <FormattedMessage
                        id={"app.game.review.content.your.score"}
                        defaultMessage={"Your Score: "}
                    />
                    {"Missed"}
                    <br />
                    <FormattedMessage
                        id={"app.game.review.content.correct.score"}
                        defaultMessage={"Correct Score: "}
                    />
                    {
                        matchedDecisions.aggregatedDecisions[activeStep].definedDecision
                            .score
                    }
                    <br />
                    <FormattedMessage
                        id={"app.game.review.content.reaction.time"}
                        defaultMessage={"Reaction Time: "}
                    />
                    {"Not Applicable"}
                </div>

                <div>
                    <CancelIcon
                        style={{
                            float: "left",
                            color: "red",
                            fontSize: "60px",
                            marginTop: "1%",
                            marginLeft: "50%",
                        }}
                    />
                </div>
            </div>

            <div className={classes.contentCenter}>
                <Button
                    className={classes.btnChallengeDecision}
                    onClick={handleOpenDialog}
                >
                    <FormattedMessage
                        id={"app.game.buttons.challenge.decision"}
                        defaultMessage={"Challenge Decision "}
                    />
                </Button>
                <Dialog open={isOpen} onClose={handleCloseDialog}>
                    <DialogTitle>
                        <FormattedMessage
                            id={"app.game.buttons.challenge.decision"}
                            defaultMessage={"Challenge Decision "}
                        />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <FormattedMessage
                                id={"app.game.review.content.challenge.decision.text"}
                                defaultMessage={
                                    "Please enter any additional remarks you may have about this decision. (Max. 200 characters.) "
                                }
                            />
                        </DialogContentText>
                        <TextField
                            autoFocus
                            value={playerNotes}
                            margin="dense"
                            id="name"
                            label="Notes"
                            multiline
                            rows={4}
                            fullWidth
                            inputProps={{ maxLength: 200 }}
                            onChange={handleChangeText}
                            variant="standard"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog}>
                            <FormattedMessage
                                id={"app.game.buttons.challenge.decision.cancel"}
                                defaultMessage={"Cancel"}
                            />
                        </Button>
                        <Button onClick={handleClickSubmit}>
                            <FormattedMessage
                                id={"app.game.buttons.challenge.decision.submit"}
                                defaultMessage={"Submit"}
                            />
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>

            <div className={classes.contentRight}>
                {matchedDecisions.aggregatedDecisions[activeStep].definedDecision.score}{" "}
                {!isNaN(
                    matchedDecisions.aggregatedDecisions[activeStep].definedDecision.score
                )
                    ? "pt"
                    : ""}
                <br />
                <b
                    style={
                        matchedDecisions.aggregatedDecisions[activeStep].definedDecision
                            .athlete === "red"
                            ? { color: "red" }
                            : { color: "blue" }
                    }
                >
                    {intl.formatMessage({
                        id: `app.ids.technique.${matchedDecisions.aggregatedDecisions[activeStep].definedDecision.technique}`,
                        defaultMessage:
                            matchedDecisions.aggregatedDecisions[activeStep].definedDecision
                                .technique,
                    }) +
                        (matchedDecisions.aggregatedDecisions[activeStep].definedDecision
                            .techniqueFreeText
                            ? `: ${matchedDecisions.aggregatedDecisions[activeStep].definedDecision.techniqueFreeText}`
                            : "")}
                </b>
            </div>
        </div>
    );
};

export default DecisionReviewContent;
